(function($) {
  
  function cbPenSlider() {
    if ($('.custom-slider-section').length) {
      console.log('========= CUSTOM SLIDER ======');

      let top_slider_option_alias = false;
      let middle_slider_option_alias = false;
      let bottom_slider_option_alias = false;

      let top_slider_json_el = $('#top_option_slider_json');
      let middle_slider_json_el = $('#middle_option_slider_json');
      let bottom_slider_json_el = $('#bottom_option_slider_json');
      if (top_slider_json_el.length > 0) {
        let top_slider_json = JSON.parse($(top_slider_json_el).text());
        for (let idx = 0; idx < top_slider_json.length; idx++) {
          top_slider_option_alias = top_slider_json[idx]['option_name_handleize'];
        }
      }
      if (middle_slider_json_el.length > 0) {
        let middle_slider_json = JSON.parse($(middle_slider_json_el).text());
        for (let idx = 0; idx < middle_slider_json.length; idx++) {
          middle_slider_option_alias = middle_slider_json[idx]['option_name_handleize'];
        }
      }
      if (bottom_slider_json_el.length > 0) {
        let bottom_slider_json = JSON.parse($(bottom_slider_json_el).text());
        for (let idx = 0; idx < bottom_slider_json.length; idx++) {
          bottom_slider_option_alias = bottom_slider_json[idx]['option_name_handleize'];
        }
      }

      const arrowPrev = "<button class='flickity-button flickity-prev-next-button previous lid-previous' type='button' aria-label='Previous'><svg class='flickity-button-icon' viewBox='0 0 100 100'><title>Previous</title><path d='M 10, 50 L 60, 100 L 67.5, 92.5 L 25, 50 L 67.5, 7.5 L 60, 0 Z' class='arrow' ></path></svg></button>",
            arrowNext = "<button class='flickity-button flickity-prev-next-button next lid-next' type='button' aria-label='Next'><svg class='flickity-button-icon' viewBox='0 0 100 100'><title>Next</title><path d='M 10, 50 L 60, 100 L 67.5, 92.5 L 25, 50 L 67.5, 7.5 L 60, 0 Z' class='arrow' transform='translate(100, 100) rotate(180)'></path></svg></button>";

      // TOP Slider
      if (top_slider_option_alias !== false) {
        const topSliderTarget = $('#main-custom-' + top_slider_option_alias).find('.main-carousel');
        const topSwatchesTarget = $('#custom-' + top_slider_option_alias + '-thumbnails');

        const swatchesCount = topSwatchesTarget.find('radio-swatch').length;
        let swatchesToShow = swatchesCount <= 5 ? 3 : 5;
        
        if ($(topSwatchesTarget).hasClass('cb-swatch-opt')) {
          
          let swatchesTopOptions = {
            slidesToShow: swatchesToShow,
            infinite: true,
            dots: false,
            asNavFor: topSliderTarget,
            centerMode: true,
            focusOnSelect: true,
            arrows:false,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: swatchesToShow
                }
              }
            ]
          };
          topSwatchesTarget.slick(swatchesTopOptions);

          let times = 3;

          topSwatchesTarget.on('afterChange', function(event, slick, currentSlide, nextSlide) {
            let currentSlideTop = $(slick.$slides.get(currentSlide));
            currentSlideTop.find('input').click();
            currentSlideTop.parents('fieldset').find('[data-option-value]').html(currentSlideTop.find('input').val());

            if (times === 0) {
              topSliderTarget.slick('slickPause');
              topSwatchesTarget.slick('slickPause');
            }
            --times;
          });
          topSliderTarget.on('init',function(event, slick, currentSlide, nextSlide){
            let currentSlideTop = $(slick.$slides.get(currentSlide)); 
            currentSlideTop.parents('.custom-slider-section').find('.loader').hide();
            currentSlideTop.parents('.custom-slider-section').find('.preloader').fadeOut();
          })

          $sliderTop = topSliderTarget.slick({
            slidesToShow: 1,
            infinite: true,
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            prevArrow: arrowPrev,
            nextArrow: arrowNext,
            asNavFor:topSwatchesTarget,
            autoplay: false,
            autoplaySpeed: 2500
          });
        } else {
          $sliderTop = topSliderTarget.slick({
            slidesToShow: 1,
            infinite: true,
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            prevArrow: arrowPrev,
            nextArrow: arrowNext,
            autoplay: false,
            autoplaySpeed: 2500
          });

          let times = 3;

          topSliderTarget.on('afterChange', function(event, slick, currentSlide, nextSlide) {
            let currentSlideTop = $(slick.$slides.get(currentSlide));  
            currentSlideTop.parents('.product-page').find('#custom-' + top_slider_option_alias + '-thumbnails .radio__button').each(function(i,k) {
              if (i == currentSlide) {
                $(this).find('input').click();
                // $(this).find('input').attr('checked', true).trigger('click');
                // $(this).find('input').parents('.radio__fieldset').find('span[data-option-value]').text($(this).find('input').find('label').data('swatch'));
              }
              
            });

            if (times === 0) {
              topSliderTarget.slick('slickPause');
            }
            --times;
          });
          $('#custom-' + top_slider_option_alias + '-thumbnails .radio__button').each(function(i,k) {
            $(this).find('label').on('click', function() {
              topSliderTarget.slick('slickGoTo', i);
            });
          });
          
          topSliderTarget.on('init',function(event, slick, currentSlide, nextSlide){
            let currentSlideTop = $(slick.$slides.get(currentSlide));
            currentSlideTop.parents('.custom-slider-section').find('.loader').hide();
            currentSlideTop.parents('.custom-slider-section').find('.preloader').fadeOut();
          });
        }

      }

      // MIDDLE Slider
      if (middle_slider_option_alias !== false) {
        const middleSliderTarget = $('#main-custom-' + middle_slider_option_alias).find('.main-carousel');
        const middleSwatchesTarget = $('#custom-' + middle_slider_option_alias + '-thumbnails');
      
        const swatchesCount = middleSwatchesTarget.find('radio-swatch').length;
        const swatchesToShow = swatchesCount <= 5 ? 3 : 5;
      
        if ($(middleSwatchesTarget).hasClass('cb-swatch-opt')) {
          let swatchesMiddleOptions = {
            slidesToShow: swatchesToShow,
            infinite: true,
            dots: false,
            asNavFor: middleSliderTarget,
            centerMode: true,
            focusOnSelect: true,
            arrows: false,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: swatchesToShow
                }
              }
            ]
          };
      
          middleSwatchesTarget.on('init', function() {
            let selectedIndex = middleSwatchesTarget.find('input:checked').closest('.swatch__button').index();
            if (selectedIndex >= 0) {
              middleSwatchesTarget.slick('slickGoTo', selectedIndex);
            }
          });
      
          middleSwatchesTarget.slick(swatchesMiddleOptions);
      
          let times = 3;
      
          middleSwatchesTarget.on('afterChange', function(event, slick, currentSlide) {
            let currentSlideMiddle = $(slick.$slides.get(currentSlide));
            currentSlideMiddle.find('input').click();
            currentSlideMiddle.parents('fieldset').find('[data-option-value]').html(currentSlideMiddle.find('input').val());
      
            if (times === 0) {
              middleSliderTarget.slick('slickPause');
              middleSwatchesTarget.slick('slickPause');
            }
            --times;
          });
      
          $sliderMiddle = middleSliderTarget.slick({
            slidesToShow: 1,
            infinite: true,
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            prevArrow: arrowPrev,
            nextArrow: arrowNext,
            asNavFor: middleSwatchesTarget,
            autoplay: false,
            autoplaySpeed: 1500
          });
      
        } else {
          $sliderMiddle = middleSliderTarget.slick({
            slidesToShow: 1,
            infinite: true,
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            prevArrow: arrowPrev,
            nextArrow: arrowNext,
            autoplay: false,
            autoplaySpeed: 1500
          });
      
          let times = 3;
      
          middleSliderTarget.on('afterChange', function(event, slick, currentSlide) {
            let currentSlideMiddle = $(slick.$slides.get(currentSlide));  
            middleSwatchesTarget.find('.radio__button').each(function(i) {
              if (i === currentSlide) {
                $(this).find('input').click();
              }
            });
      
            if (times === 0) {
              middleSliderTarget.slick('slickPause');
            }
            --times;
          });
      
          $('#custom-' + middle_slider_option_alias + '-thumbnails .radio__button').each(function(i) {
            $(this).find('label').on('click', function() {
              middleSliderTarget.slick('slickGoTo', i);
            });
          });
      
          middleSliderTarget.on('init', function(event, slick, currentSlide) {
            let currentSlideMiddle = $(slick.$slides.get(currentSlide));
            currentSlideMiddle.parents('.custom-slider-section').find('.loader').hide();
            currentSlideMiddle.parents('.custom-slider-section').find('.preloader').fadeOut();
          });
        }
      }

      // BOTTOM Slider
      if (bottom_slider_option_alias !== false) {
        const bottomSliderTarget = $('#main-custom-' + bottom_slider_option_alias).find('.main-carousel');
        const bottomSwatchesTarget = $('#custom-' + bottom_slider_option_alias + '-thumbnails');

        const swatchesCount = bottomSwatchesTarget.find('radio-swatch').length;
        const swatchesToShow = swatchesCount <= 5 ? 3 : 5;

        if ($(bottomSwatchesTarget).hasClass('cb-swatch-opt')) {
          let swatchesBottomOptions = {
            slidesToShow: swatchesToShow,
            infinite: true,
            dots: false,
            asNavFor: bottomSliderTarget,
            centerMode: true,
            focusOnSelect: true,
            arrows:false,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: swatchesToShow
                }
              }
            ]
          };
          bottomSwatchesTarget.slick(swatchesBottomOptions);

          let times = 3;

          bottomSwatchesTarget.on('afterChange', function(event, slick, currentSlide, nextSlide) {
            let currentSlideBottom = $(slick.$slides.get(currentSlide));
            currentSlideBottom.find('input').click();
            currentSlideBottom.parents('fieldset').find('[data-option-value]').html(currentSlideBottom.find('input').val());

            if (times === 0) {
              bottomSliderTarget.slick('slickPause');
              bottomSwatchesTarget.slick('slickPause');
            }
            --times;
          });
          bottomSliderTarget.on('init',function(event, slick, currentSlide, nextSlide){
            let currentSlideBottom = $(slick.$slides.get(currentSlide)); 
            currentSlideBottom.parents('.custom-slider-section').find('.loader').hide();
            currentSlideBottom.parents('.custom-slider-section').find('.preloader').fadeOut();
          });

          $sliderBottom = bottomSliderTarget.slick({
            slidesToShow: 1,
            infinite: true,
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            prevArrow: arrowPrev,
            nextArrow: arrowNext,
            asNavFor:bottomSwatchesTarget,
            autoplay: false,
            autoplaySpeed: 2000
          });
        } else {
          $sliderBottom = bottomSliderTarget.slick({
            slidesToShow: 1,
            infinite: true,
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            prevArrow: arrowPrev,
            nextArrow: arrowNext,
            autoplay: false,
            autoplaySpeed: 2000
          });

          let times = 3;

          bottomSliderTarget.on('afterChange', function(event, slick, currentSlide, nextSlide) {
            let currentSlideBottom = $(slick.$slides.get(currentSlide));  
            currentSlideBottom.parents('.product-page').find('#custom-' + bottom_slider_option_alias + '-thumbnails .radio__button').each(function(i,k) {
              if (i == currentSlide) {
                $(this).find('input').click();
              }

            });

            if (times === 0) {
              bottomSliderTarget.slick('slickPause');
            }
            --times;
          });
          $('#custom-' + bottom_slider_option_alias + '-thumbnails .radio__button').each(function(i,k) {
            $(this).find('label').on('click', function() {
              bottomSliderTarget.slick('slickGoTo', i);
            });
          });
          
          bottomSliderTarget.on('init',function(event, slick, currentSlide, nextSlide){
            let currentSlideBottom = $(slick.$slides.get(currentSlide));
            currentSlideBottom.parents('.custom-slider-section').find('.loader').hide();
            currentSlideBottom.parents('.custom-slider-section').find('.preloader').fadeOut();
          });
        }

      }

      $('.custom-slider-container .flickity-prev-next-button').on('click', function() {
        if (top_slider_option_alias !== false) {
          $('#main-custom-' + top_slider_option_alias).find('.main-carousel').slick('slickPause');
        }
        if (middle_slider_option_alias !== false) {
          $('#main-custom-' + middle_slider_option_alias).find('.main-carousel').slick('slickPause');
        }
        if (bottom_slider_option_alias !== false) {
          $('#main-custom-' + bottom_slider_option_alias).find('.main-carousel').slick('slickPause');
        }
      });

      $('label.cb-slider-option-label').on('click', function() {
        if (top_slider_option_alias !== false) {
          $('#main-custom-' + top_slider_option_alias).find('.main-carousel').slick('slickPause');
        }
        if (middle_slider_option_alias !== false) {
          $('#main-custom-' + middle_slider_option_alias).find('.main-carousel').slick('slickPause');
        }
        if (bottom_slider_option_alias !== false) {
          $('#main-custom-' + bottom_slider_option_alias).find('.main-carousel').slick('slickPause');
        }
      });

      // $('.cb-slider-option-label').on('click', function() {
      // // $('.radio__inputs.cb-swatch-opt').on('click', function() {
      //   if (top_slider_option_alias !== false) {
      //     $('#main-custom-' + top_slider_option_alias).find('.main-carousel').slick('slickPause');
      //   }
      //   if (middle_slider_option_alias !== false) {
      //     $('#main-custom-' + middle_slider_option_alias).find('.main-carousel').slick('slickPause');
      //   }
      //   if (bottom_slider_option_alias !== false) {
      //     $('#main-custom-' + bottom_slider_option_alias).find('.main-carousel').slick('slickPause');
      //   }
      // });

      if (top_slider_option_alias !== false) {
        $('#main-custom-' + top_slider_option_alias).find('.main-carousel').on('swipe', function(event, slick, direction) {
          $('#main-custom-' + top_slider_option_alias).find('.main-carousel').slick('slickPause');
          if (middle_slider_option_alias !== false) {
            $('#main-custom-' + middle_slider_option_alias).find('.main-carousel').slick('slickPause');
          }
          if (bottom_slider_option_alias !== false) {
            $('#main-custom-' + bottom_slider_option_alias).find('.main-carousel').slick('slickPause');
          }
        });
      }

      if (middle_slider_option_alias !== false) {
        $('#main-custom-' + middle_slider_option_alias).find('.main-carousel').on('swipe', function(event, slick, direction) {
          if (top_slider_option_alias !== false) {
            $('#main-custom-' + top_slider_option_alias).find('.main-carousel').slick('slickPause');
          }
          $('#main-custom-' + middle_slider_option_alias).find('.main-carousel').slick('slickPause');
          if (bottom_slider_option_alias !== false) {
            $('#main-custom-' + bottom_slider_option_alias).find('.main-carousel').slick('slickPause');
          }
        });
      }

      if (bottom_slider_option_alias !== false) {
        $('#main-custom-' + bottom_slider_option_alias).find('.main-carousel').on('swipe', function(event, slick, direction) {
          if (top_slider_option_alias !== false) {
            $('#main-custom-' + top_slider_option_alias).find('.main-carousel').slick('slickPause');
          }
          if (middle_slider_option_alias !== false) {
            $('#main-custom-' + middle_slider_option_alias).find('.main-carousel').slick('slickPause');
          }
          $('#main-custom-' + bottom_slider_option_alias).find('.main-carousel').slick('slickPause');
        });
      }
      
      if (window.matchMedia("(min-width: 768px)").matches && $('.position--gallery').length) {
        $('.custom-options-container').insertBefore('.product__main__content .product__block__buttons');
      } 
      if (window.matchMedia("(max-width: 767px)").matches) {
        // $(".product__block__title, div[id^='shopify-block-judge_me_reviews_preview_badge_']").wrapAll("<div class='title-review'>");
        // $('.title-review').prependTo('.product-page');
        // $('.cb-gallery-js').insertAfter('.product__main__content .product__block__buttons');
      }
  
    } //endif
  } //end slider function

  
  $(document).ready(function() {
    cbPenSlider();
    if ($('.custom-slider-section').length) {
      // let container = document.querySelector('.custom-slider-section');
      // const productRoot = container.closest('[x-data]');
      // const productData = Alpine.$data(productRoot);

      // container.addEventListener('click', (e) => {
      //   const swatch = e.target.closest('[data-swatch]');
      //   if (!swatch) return;
      //   if (swatch.closest('.slick-cloned')) return;

      //   productData.$sectionApi.navigate(swatch.dataset.variantUrl, 'replace');
      // });
    }
    
  });
})(jQuery);